/*
 * START_MODULE_CONTRACT
 *   PURPOSE: Toggle locale between en and ru by rewriting current URL path
 *   PROPS:   none
 *   STATE:   reads locale from URL params
 *   DEPENDS: M-BTN (Button), next/link, next/navigation, @phosphor-icons/react
 *   EMITS:   navigation via Link href
 *   ACCESSIBILITY: Globe icon aria-hidden, text label shows target locale
 *   LINKS:   M-LNG
 * END_MODULE_CONTRACT
 *
 * CHANGE_SUMMARY
 *   [2026-06-12] Added GRACE MODULE_CONTRACT and semantic blocks — no behavior change
 */

"use client"

import Link from "next/link"
import { usePathname, useParams } from "next/navigation"
import { Globe } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"

export function LangSwitch() {
  // --- ResolveLocales ---
  const pathname = usePathname()
  const params = useParams()
  const locale = (params?.locale as string) || "en"
  const otherLocale = locale === "en" ? "ru" : "en"

  // --- BuildSwitchPath ---
  const cleanPath = pathname.replace(`/${locale}`, "") || "/"
  const switchPath = `/${otherLocale}${cleanPath}`

  // --- RenderToggle ---
  return (
    <Link href={switchPath}>
      <Button variant="ghost" size="sm">
        <Globe weight="regular" aria-hidden="true" />
        <span className="text-xs font-semibold text-primary">{otherLocale.toUpperCase()}</span>
      </Button>
    </Link>
  )
}
